import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';
import { HrData, HrDesignationLists } from '../../data/system/hr';

@Injectable()
export class HrService extends HrData {

  constructor(private http: HttpClient) { super(); }

  getDesignation(): Observable<HrDesignationLists> {
    const host = `${env.host}${env.endpoint.hr_designation}`;
    return this.http.get<HrDesignationLists>(host).pipe(
      tap(data => console.log(`hr->getDesignation->data`, data))
    );
  }

  getDesignationEmployee(id: number | string): Observable<HrDesignationLists> {
    const host = `${env.host}${env.endpoint.hr_designation_employee}${id}`;
    return this.http.get<HrDesignationLists>(host).pipe(
      tap(data => console.log(`hr->getDesignation->data`, data))
    );
  }

  getEmployeeByEmpCode(id: number | string): Observable<HrDesignationLists> {
    const host = `${env.host}${env.endpoint.hr_employee.replace(":id", id)}`;
    return this.http.get<HrDesignationLists>(host).pipe(
      tap(data => console.log(`hr->employee->data`, data))
    );
  }

  searchEmployee(name: string): Observable<any> {
    const host = `${env.host}${env.endpoint.hr_search_employee}`
    return this.http.post<any>(host, { name });
  }

}
